import { columnFilterValuesEqual } from "@/lib/sync-global-column-filters";

/**
 * Column filters that narrow both the list and the map, and that more than one
 * of licenses, foreclosure cases, and short-term rentals can show.
 * Keys in a group are the same selection stored under each list's column id.
 */
export const SHARED_TEXT_COLUMN_GROUPS = {
  city: ["property.city", "property_address_city", "city"],
  state: ["property.state", "property_address_state"],
  zip: ["property.zipcode", "property_address_zip"],
  apn: ["property.apn", "apn"],
} as const;

export type SharedTextColumnGroup = keyof typeof SHARED_TEXT_COLUMN_GROUPS;

export const LICENSE_SHARED_TEXT_COLUMNS: Record<
  SharedTextColumnGroup,
  string
> = {
  city: "property.city",
  state: "property.state",
  zip: "property.zipcode",
  apn: "property.apn",
};

export const CASE_SHARED_TEXT_COLUMNS: Record<SharedTextColumnGroup, string> = {
  city: "property_address_city",
  state: "property_address_state",
  zip: "property_address_zip",
  apn: "apn",
};

export const STR_SHARED_TEXT_COLUMNS: Partial<
  Record<SharedTextColumnGroup, string>
> = {
  city: "city",
};

export function reconcileSharedTextValues({
  values,
  changed,
  initializing,
}: {
  values: Array<string[] | undefined>;
  changed: boolean[];
  initializing: boolean;
}): Array<string[] | undefined> {
  const normalized = values.map((entry) =>
    entry && entry.length > 0 ? entry : undefined,
  );
  const publish = (source: string[] | undefined) =>
    normalized.map(() => source);

  if (initializing) {
    const source = normalized.find((entry) => entry !== undefined);
    if (!source) return normalized;
    if (normalized.every((entry) => columnFilterValuesEqual(entry, source))) {
      return normalized;
    }
    return publish(source);
  }

  const index = changed.findIndex(Boolean);
  if (index < 0) return normalized;
  return publish(normalized[index]);
}
